import React from "react";

// Professional DEA S.R.L. logo mark (brake-disc / wheel-hub automotive motif)
export default function LogoMark({ size = 46 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-label="DEA S.R.L." role="img">
      <rect width="64" height="64" rx="14" fill="#123a63" />
      <g transform="translate(32 25)">
        <circle r="12" fill="none" stroke="#4f9cf0" strokeWidth="3" />
        <circle r="3.4" fill="#4f9cf0" />
        <g fill="#4f9cf0">
          <circle cx="0" cy="-8" r="1.7" />
          <circle cx="6.9" cy="-4" r="1.7" />
          <circle cx="6.9" cy="4" r="1.7" />
          <circle cx="0" cy="8" r="1.7" />
          <circle cx="-6.9" cy="4" r="1.7" />
          <circle cx="-6.9" cy="-4" r="1.7" />
        </g>
      </g>
      <text x="32" y="53" fontFamily="Arial, Helvetica, sans-serif" fontSize="15" fontWeight="700" fill="#ffffff" textAnchor="middle" letterSpacing="1">DEA</text>
    </svg>
  );
}
